import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import LiterarySidebar from '../Literaryclub2023/components/LiterarySidebar';
import Sidebar2026 from '../Literaryclub2023/components/Sidebar2026';

const Hindicca2class2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Hindicca2class/7.webp`;


  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        }
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                              Topic: Festive Traditions Showcase	 
                                </Typography>
                                         <br/>

                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 2      Date: 18 September 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Love nature and be kind to animals"

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The students of Class 2 enthusiastically participated in the Hindi Inter-House CCA Competition held on Friday, 18 September 2026. The theme of the competition was ‘Festive Traditions Showcase’. The activity aimed to familiarise students with India's rich cultural heritage and diversity
 while nurturing their communication, presentation and creative expression skills. 
                                <br></br>
In the preliminary round of the competition, students confidently presented a few lines about any one state of India. This activity helped enhance their confidence, 
Hindi speaking skills and appreciation for India's diverse cultural traditions.        
                                <br></br>
The final round, held on 18 September 2026, witnessed the finalists creatively dressed according to their respective states, using beautiful and colourful props to enhance their presentations. They confidently shared interesting facts about their chosen states, including their culture, traditions, festivals, food, attire and heritage. The activity provided an enriching opportunity for students to express themselves, develop
 confidence, enhance their Hindi communication skills and appreciate the vibrant cultural diversity of India.

                                 <br></br>
      </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
“Celebrating Traditions, Discovering India!”
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default Hindicca2class2026;